import React from 'react'
import { Route, Routes } from 'react-router-dom'
// import { PageTitle } from '../../../_metronic/layout/core'
// import { useIntl } from 'react-intl'
// import {SharedAccessBreadCrum} from './core/_constants'
// import { SharedAccessBreadcrum } from './core/_constants'
// import {SharedAccess} from './view/SharedAccess'
//import { KTSVG } from '../../../_metronic/helpers'

const SharedAccessRoutes = () => {
  // const { formatMessage } = useIntl()
  // const { SharedAccessBreadCrum } = SharedAccessBreadcrum()
  // function storeSearchValue(value: string): void {
  //   throw new Error('Function not implemented.')
  // }

  return (
    <div className='mt-3 px-6'>
      <Routes>
        <Route
          index
          element={
            <>
              {/* <PageTitle
                breadcrumbs={SharedAccessBreadCrum}
                description={formatMessage({ id: 'Shared Access' })}
              >
                {formatMessage({ id: 'Shared Access' })}
              </PageTitle> */}
            </>
          }
        />
      </Routes>
    </div>
  )
}

export default SharedAccessRoutes
